import React, { useState } from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { EndorsementsList } from './components/EndorsementsList';
import { EndorsementsModal } from './components/EndorsementsModal';

export const EndorsementsContainer: React.FC = () => {
	const [isEndorsementsModalOpen, setIsEndorsementsModalOpen] = useState(false);

	return (
		<div className="flex flex-col">
			<Text className="text-size-heading-small md:text-size-heading-large">
				<Translate value="corgi.petition.details.endorsements.heading" />
			</Text>
			<Text variant="body" size="large" className="mt-4">
				<Translate value="corgi.petition.details.endorsements.subheading" />
			</Text>
			<div className="my-6">
				<EndorsementsList setIsEndorsementsModalOpen={setIsEndorsementsModalOpen} />
			</div>

			<EndorsementsModal
				isOpen={isEndorsementsModalOpen}
				onClose={() => setIsEndorsementsModalOpen(false)}
				setIsOpen={setIsEndorsementsModalOpen}
			/>

			<Button
				variant="secondary"
				size="small"
				data-qa="view-all-endorsements-button"
				data-testid="view-all-endorsements-button"
				onClick={() => setIsEndorsementsModalOpen(true)}
			>
				<Translate value="corgi.petition.details.endorsements.view_all_button" />
			</Button>
		</div>
	);
};
